export default __webpack_public_path__ + "static/media/6_Conin_entrega_de_reconocimientos.832a6507.mp3";